export const formatSearchData = (data) => {
    Object.keys(data).map(key => {
        const type = typeof data[key]
        if (type !== 'boolean' && !data[key]) delete data[key]
    })
}
export const formatUnitTree = (tree, disType) => {
    tree && tree.length && tree.map(item => {
        item.disabled = disType == item.type;
        formatUnitTree(item.childrenList, disType)
    })
}